/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { wrap } from "@/apis/wrap";
import { DashboardApi } from "@/apis/clients";

const dashboardApi = {
  index: wrap(DashboardApi, DashboardApi.prototype.getDashboard),
  chart: wrap(DashboardApi, DashboardApi.prototype.getDashboardChart),
};

export default dashboardApi;
